export enum LicenseCode {
  hr = 'hr',
  okr = 'okr',
  dailyReport = 'dailyReport',
  taskManagement = 'taskManagement',
  timesheet = 'timesheet',
  documentManagement = 'documentManagement',
  leaveTracking = 'leaveTracking',
}
